import { render, staticRenderFns } from "./area-sheet.vue?vue&type=template&id=0947713e&scoped=true&lang=html&"
import script from "./area-sheet.vue?vue&type=script&lang=js&"
export * from "./area-sheet.vue?vue&type=script&lang=js&"
import style0 from "./area-sheet.vue?vue&type=style&index=0&id=0947713e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947713e",
  null
  
)

export default component.exports